export const useDetailsConfig = () => {
  return { usedByBrandFloorsVisible: false };
};
